import { Component, OnInit, ViewChild  } from '@angular/core';
import { ListRootContainersComponent } from '../list-root-containers/list-root-containers.component';
import { CloudFolderContentComponent } from '../cloud-folder-content/cloud-folder-content.component';
import { AutomationExporterService } from '../automation-exporter.service';
import { AutomationService } from '../automation.service';
import { AuthService } from '../auth.service';


@Component({
  selector: 'app-exporter-hsbshare',
  templateUrl: './exporter-hsbshare.component.html',
  styleUrls: ['./exporter-hsbshare.component.css']
})
export class ExporterHsbshareComponent implements OnInit {

  inputMap;
  companyFolder;
  outputFolder;
  mode;
  exporter;

  result;
  resultHeader;

  selectedProject;
  previousSelectedProject;

  showSpinner;

  @ViewChild('listRootContainer') listRootContainer: ListRootContainersComponent;
  @ViewChild('selectInputMap') selectInputMap: CloudFolderContentComponent;
  @ViewChild('selectCompanyFolder') selectCompanyFolder: CloudFolderContentComponent;
  @ViewChild('selectOutputFolder') selectOutputFolder: CloudFolderContentComponent;
  

  constructor(private automationExporterService: AutomationExporterService,
              private authService: AuthService,
              private automationService: AutomationService) { }

  ngOnInit() {
    this.listRootContainer.listRootContainerHsbShare();
  }

  onRootContainerChanged(rootContainerValue){
    var projectName = rootContainerValue.Name;
    var projectId = rootContainerValue.projectId;

    this.selectedProject = rootContainerValue.Name;

    if(this.selectedProject != this.previousSelectedProject)
    {
      this.selectInputMap.listHsbShare(projectId, projectName, '/');
      this.selectCompanyFolder.listHsbShare(projectId, projectName, '/');
      this.selectOutputFolder.listHsbShare(projectId, projectName, '/');
      this.previousSelectedProject = this.selectedProject;
    }
  }
  run(){

    this.result = ""
    this.resultHeader = "";
    this.showSpinner = true;

    let executionContext = this.automationExporterService.
                            getExecutionContextDefaultCopyHsbShare(this.inputMap,
                              this.companyFolder,
                              this.outputFolder,
                              this.authService.getAccessToken()
                            );

    this.automationExporterService.updateCommandLineParameters(executionContext, 
                              this.mode,
                              this.exporter);  

    this.automationService.executeContext(executionContext)
                              .then(result => {
                                  this.showSpinner = false;
                                  if(Array.isArray(result) && result.length > 0){
                                      var resText = result[0].replace("Upload Success:", "");
                                      this.resultHeader = "Exporter finised executing. Output zipped folder uploaded to: " ;
                                      this.result = resText;
                                  }else{
                                    this.resultHeader = "There was an error executing exporter: ";
                                    this.result = JSON.stringify(result);
                                  }
                              }, error => {
                                  this.showSpinner = false;
                                  this.resultHeader = "There was an error executing exporter: ";
                                  this.result = JSON.stringify(error);
                              });                             

  }
  inputMapChanged(e){
    this.inputMap = e.selectedFileURL;
  }
  companyFolderChanged(e){
    this.companyFolder = e.selectedFileURL;
  }
  selectOutputFolderChanged(e){
    this.outputFolder = e.selectedFileURL;
  }
}



// WEBPACK FOOTER //
// ./src/app/exporter-hsbshare/exporter-hsbshare.component.ts